module.exports = __webpack_public_path__ + "static/media/qr_payment.bbcb81bf.jpg";